import React,{useEffect, useState} from 'react';
import useFetch from '../CustomHooks/useFetch';

import Logo from '../Images/ht_logo_final.png';
import '../Styles/Login.scss';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';





export default function PasswordReset () {

    const [response, fetchData] = useFetch();
    const [status, setStatus] = useState('Verifying');
    const [code, setCode] = useState('');
    const [password, setPassword] = useState('');
    const [passwordAgain, setPasswordAgain] = useState('');
    const [errorMessages, setErrorMessages] = useState({email:'',yourName: '', restaurantName : '', password : '', passwordAgain : ''});
    const [guiLanguage, setGuiLanguage] = useState('en');

    const setErrorMessage = (key, value) =>{
        setErrorMessages( {...errorMessages, [key] : value});
    }

    useEffect(
        () => {
            if (window.location.href.indexOf('lang=tr') > 0) {
                setGuiLanguage('tr');
            }
        }, []
    )


    useEffect(
        ()=> {
            let code = window.location.pathname.replace('/passwordReset/','');
            console.log(code);
            setCode(code);

        },[]
    )



    useEffect(
        ()=> {
            async function f() {
               if(response != null) {
                   if(response.length != 0) {
                        if(response){   
                            setStatus('Verified');         
                        } else {
                            setStatus('Rejected');    
                        }
                   }
               }
           }
           f();
       },[response]
   )

   const submitForm = async (e) => {
    e.preventDefault();

    let validated = true;

   
    if (password != passwordAgain) {
        setErrorMessage('passwordAgain', guiLanguage == 'tr' ? 'Girdiğiniz ikinci parolanın ilki ile aynı olması gerekiyor' : 'Re-enter your password confirmation so it matches your password.');
        validated = false;
    }
    else {
        setErrorMessage('passwordAgain', '');
    }

    
    if(validated) {
        fetchData(
            {
                url: '/admin/auth/reset-password/' + code,
                method: 'PUT',
                postData: {
                    password: password,
                },
            }
        )
    }
}
    
    return (
       <div className="login">
            <div className="login__inner-wrapper">
                {response.length == 0 ?
                    <React.Fragment>
                        <img src={Logo} style={{ alignSelf: 'center', width: '300px' }}></img>
                        <div style={{ marginTop: '20px' }}>{ guiLanguage== 'tr'?'Lütfen yeni parolanızı 2 kere girin.': 'Please type your new password twice.'}</div>
                        <TextField id="password" type="password" label={guiLanguage == 'tr'? 'Parola' : 'Password'} value={password} onChange={(e)=> setPassword(e.target.value)}  helperText={errorMessages.password} error={errorMessages.password == ''? false : true}/>
                        <TextField id="passwordAgain" type="password" label={guiLanguage == 'tr'? 'Parola tekrar' : 'Password again'} value={passwordAgain} onChange={(e)=> setPasswordAgain(e.target.value)}  helperText={errorMessages.passwordAgain} error={errorMessages.passwordAgain == ''? false : true}/>
                        <Button id="submitButton" variant="contained" color="primary" style={{marginTop:'30px'}} onClick={submitForm}>
                        {guiLanguage == 'tr'? 'Parolayı değiştir' : 'Reset password'}
                        </Button>
                    </React.Fragment>
                    : null}
                {response.length != 0 && response ?
                    <div className="password-reset-success">
                        {guiLanguage == 'tr'? 
                        'Parolayı başarılı bir şekilde değiştirdiniz' : 
                        'We have successfully reset your password. You can login< now with your new password.'}
                        
                    </div>   
                : null}
                {response.length != 0 && !response ?
                <div  className="password-reset-fail">
                    {guiLanguage == 'tr'? 
                        'Parolanız değiştirilemedi. Lütfen destek ekibi ile iletişime geçin.' : 
                        'Can not reset your password. Please contact support.'}
                    </div>
                : null}
            </div>
        </div>
    )
}

function LoginLink(){
    return (
        <React.Fragment>
            <a href="/Login">Login</a>
        </React.Fragment>
    )
}
